import { IInfrastructureGeoObjectsResponse } from '../../../common/repositories/infrastructure-caching/entities/infrastructure/InfrastructureGeoObjectsResponse';
import { IInfrastructurePointItem } from '../../types/infrastructure';

export function prepareInfrastructureItems(response: IInfrastructureGeoObjectsResponse): IInfrastructurePointItem[] {
  const items: IInfrastructurePointItem[] = [];

  for (const { description, geography, id, name, type } of response.infrastructure) {
    if (geography.type !== 'Point') {
      continue;
    }

    items.push({
      description: description || undefined,
      type,
      name,
      id,
      coordinates: geography.coordinates,
    });
  }

  return items;
}
